import { FrameContainerRent } from '@Modules/Orders';
import { type RouteObject } from 'react-router';

/** The container rent frame with its two table modes. */
// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function setupContainerRentRouting(): RouteObject {
    return {
        path: 'container_rent',
        element: <FrameContainerRent />,
    };
}
